export const sampleData = {
    excludeWatchListIds: [4, 5],
    listData: [
        {
            drName: 'Apple CDR(CAD Hedged) AAPL',
            drPrice: '$1.0000',
            drRatio: 0.10718919,
            forwardRate: '1.4890876',
            drTicker: 'APPL',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            link: '/test-page',
            id: 1,
            date: '2023-01-21',
            hideWatchList: true,
        },
        {
            drName: 'Amazon CDR(CAD Hedged) aaz',
            drPrice: '$1.1000',
            drRatio: 0.6689989,
            forwardRate: '1.4890876',
            drTicker: 'AMZ',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'CAD',
            gics: 'GICS',
            link: '/test-page',
            id: 2,
            date: '2020-08-24',
        },
        {
            drName: 'Cisco CDR(CAD Hedged)',
            drPrice: '$1.2000',
            drRatio: 0.343434234,
            forwardRate: '1.4890876',
            drTicker: 'CISC',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            id: 3,
            date: '2020-05-10',
        },
        {
            drName: 'HKD CDR(CAD Hedged)',
            drPrice: '$1.3000',
            drRatio: 0.23565476,
            forwardRate: '1.4890876',
            drTicker: 'APPL',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'CAD',
            gics: 'GICS',
            id: 4,
            date: '2019-03-20',
            hideWatchList: true,
        },
        {
            drName: 'Apple CDR(CAD Hedged) AAPL',
            drPrice: '$1.0000',
            drRatio: 0.10718919,
            forwardRate: '1.4890876',
            drTicker: 'APPL',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            link: '/test-page',
            id: 5,
            date: '2020-01-20',
        },
        {
            drName: 'Amazon CDR(CAD Hedged)',
            drPrice: '$2.1000',
            drRatio: 0.6689989,
            forwardRate: '1.4890876',
            drTicker: 'AMZ',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            link: '/test-page',
            id: 6,
            date: '2021-07-22',
        },
        {
            drName: 'Cisco CDR(CAD Hedged)',
            drPrice: '$2.2000',
            drRatio: 0.343434234,
            forwardRate: '1.4890876',
            drTicker: 'CISC',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            id: 7,
            date: '2022-11-22',
        },
        {
            drName: 'HKD CDR(CAD Hedged)',
            drPrice: '$2.3000',
            drRatio: 0.23565476,
            forwardRate: '1.4890876',
            drTicker: 'APPL',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            id: 8,
            date: '2021-06-03',
        },
        {
            drName: 'Apple CDR(CAD Hedged) AAPL',
            drPrice: '$2.0000',
            drRatio: 0.10718919,
            forwardRate: '1.4890876',
            drTicker: 'APPL',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            link: '/test-page',
            id: 9,
            date: '2019-02-28',
        },
        {
            drName: 'Amazon CDR(CAD Hedged)',
            drPrice: '$3.1000',
            drRatio: 0.6689989,
            forwardRate: '1.4890876',
            drTicker: 'AMZ',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            link: '/test-page',
            id: 10,
            date: '2022-01-04',
        },
        {
            drName: 'Cisco CDR(CAD Hedged)',
            drPrice: '$3.2000',
            drRatio: 0.343434234,
            forwardRate: '1.4890876',
            drTicker: 'CISC',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            id: 11,
            date: '2020-03-23',
        },
        {
            drName: 'HKD CDR(CAD Hedged)',
            drPrice: '$4.4000',
            drRatio: 0.23565476,
            forwardRate: '1.4890876',
            drTicker: 'APPL',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            id: 12,
            date: '2020-10-23',
        },
        {
            drName: 'Apple CDR(CAD Hedged) AAPL',
            drPrice: '$5.0000',
            drRatio: 0.10718919,
            forwardRate: '1.4890876',
            drTicker: 'APPL',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            link: '/test-page',
            id: 13,
            date: '2020-10-11',
        },
        {
            drName: 'Amazon CDR(CAD Hedged)',
            drPrice: '$6.1000',
            drRatio: 0.6689989,
            forwardRate: '1.4890876',
            drTicker: 'AMZ',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            link: '/test-page',
            id: 14,
            date: '2023-05-16',
        },
        {
            drName: 'Cisco CDR(CAD Hedged)',
            drPrice: '$7.2000',
            drRatio: 0.343434234,
            forwardRate: '1.4890876',
            drTicker: 'CISC',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            id: 15,
            date: '2018-07-15',
        },
        {
            drName: 'HKD CDR(CAD Hedged)',
            drPrice: '$8.3000',
            drRatio: 0.23565476,
            forwardRate: '1.4890876',
            drTicker: 'APPL',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            id: 16,
            date: '2018-01-15',
        },
        {
            drName: 'Apple CDR(CAD Hedged) AAPL',
            drPrice: '$9.0000',
            drRatio: 0.10718919,
            forwardRate: '1.4890876',
            drTicker: 'APPL',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            link: '/test-page',
            id: 17,
            date: '2019-01-07',
        },
        {
            drName: 'Amazon CDR(CAD Hedged)',
            drPrice: '$10.1000',
            drRatio: 0.6689989,
            forwardRate: '1.4890876',
            drTicker: 'AMZ',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            link: '/test-page',
            id: 18,
            date: '2020-09-22',
        },
        {
            drName: 'Cisco CDR(CAD Hedged)',
            drPrice: '$11.2000',
            drRatio: 0.343434234,
            forwardRate: '1.4890876',
            drTicker: 'CISC',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            id: 19,
            date: '2022-01-04',
        },
        {
            drName: 'HKD CDR(CAD Hedged)',
            drPrice: '$12.3000',
            drRatio: 0.23565476,
            forwardRate: '1.4890876',
            drTicker: 'APPL',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            id: 20,
            date: '2022-10-10',
        },
        {
            drName: 'Apple CDR(CAD Hedged) AAPL',
            drPrice: '$13.0000',
            drRatio: 0.10718919,
            forwardRate: '1.4890876',
            drTicker: 'APPL',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            link: '/test-page',
            id: 21,
            date: '2020-10-01',
        },
        {
            drName: 'Amazon CDR(CAD Hedged)23',
            drPrice: '$14.1000',
            drRatio: 0.6689989,
            forwardRate: '1.4890876',
            drTicker: 'AMZ',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            link: '/test-page',
            id: 22,
            date: '2019-11-16',
        },
        {
            drName: 'Cisco CDR(CAD Hedged)',
            drPrice: '$15.2000',
            drRatio: 0.343434234,
            forwardRate: '1.4890876',
            drTicker: 'CISC',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            id: 23,
            date: '2022-03-28',
        },
        {
            drName: 'HKD CDR(CAD Hedged)',
            drPrice: '$16.3000',
            drRatio: 0.23565476,
            forwardRate: '1.4890876',
            drTicker: 'APPL',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            id: 24,
            date: '2018-02-07',
        },
        {
            drName: 'Apple CDR(CAD Hedged) AAPL',
            drPrice: '$17.0000',
            drRatio: 0.10718919,
            forwardRate: '1.4890876',
            drTicker: 'APPL',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            link: '/test-page',
            id: 25,
            date: '2019-12-12',
        },
        {
            drName: 'Amazon CDR(CAD Hedged)',
            drPrice: '$18.1000',
            drRatio: 0.6689989,
            forwardRate: '1.4890876',
            drTicker: 'AMZ',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            link: '/test-page',
            id: 26,
            date: '2019-02-10',
        },
        {
            drName: 'Cisco CDR(CAD Hedged)',
            drPrice: '$19.2000',
            drRatio: 0.343434234,
            forwardRate: '1.4890876',
            drTicker: 'CISC',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            id: 27,
            date: '2019-06-19',
        },
        {
            drName: 'HKD CDR(CAD Hedged)',
            drPrice: '$20.3000',
            drRatio: 0.23565476,
            forwardRate: '1.4890876',
            drTicker: 'APPL',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            id: 28,
            date: '2022-01-23',
        },
        {
            drName: 'Apple CDR(CAD Hedged) AAPL',
            drPrice: '$21.0000',
            drRatio: 0.10718919,
            forwardRate: '1.4890876',
            drTicker: 'APPL',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            link: '/test-page',
            id: 29,
            date: '2021-02-02',
        },
        {
            drName: 'Amazon CDR(CAD Hedged)',
            drPrice: '$22.1000',
            drRatio: 0.6689989,
            forwardRate: '1.4890876',
            drTicker: 'AMZ',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            link: '/test-page',
            id: 30,
            date: '2022-12-15',
        },
        {
            drName: 'Cisco CDR(CAD Hedged)',
            drPrice: '$23.2000',
            drRatio: 0.343434234,
            forwardRate: '1.4890876',
            drTicker: 'CISC',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            id: 31,
            date: '2022-02-28',
        },
        {
            drName: 'HKD CDR(CAD Hedged)',
            drPrice: '$24.3000',
            drRatio: 0.23565476,
            forwardRate: '1.4890876',
            drTicker: 'APPL',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            id: 32,
            date: '2022-03-28',
        },
        {
            drName: 'Apple CDR(CAD Hedged) AAPL',
            drPrice: '$1.0000',
            drRatio: 0.10718919,
            forwardRate: '1.4890876',
            drTicker: 'APPL',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            link: '/test-page',
            id: 33,
            date: '2019-04-20',
        },
        {
            drName: 'Amazon CDR(CAD Hedged)',
            drPrice: '$1.1000',
            drRatio: 0.6689989,
            forwardRate: '1.4890876',
            drTicker: 'AMZ',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            link: '/test-page',
            id: 34,
            date: '2019-07-04',
        },
        {
            drName: 'Cisco CDR(CAD Hedged)',
            drPrice: '$1.2000',
            drRatio: 0.343434234,
            forwardRate: '1.4890876',
            drTicker: 'CISC',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            id: 35,
            date: '2022-03-16',
        },
        {
            drName: 'HKD CDR(CAD Hedged)',
            drPrice: '$1.3000',
            drRatio: 0.23565476,
            forwardRate: '1.4890876',
            drTicker: 'APPL',
            underlyingTicker: 'APPL',
            exchange: 'NYSE',
            country: 'USA',
            gics: 'GICS',
            id: 36,
            date: '2022-08-08',
        },
    ],
};
